// @flow

import { type RecaptchaV3Result, type GrecaptchaV3 } from './types';
import { getEnvVarOrCry } from '@tectonics/commons/env-parameter';
import { loadRecaptchaV3 } from './load-recaptcha-v3';
import { RecaptchaExecutionError } from '../../commons/errors/recaptcha-execution-error';

export async function executeRecaptchaV3(action: string): Promise<RecaptchaV3Result> {
  const grecaptcha: GrecaptchaV3 = await loadRecaptchaV3();
  const siteKey = getEnvVarOrCry('SITE_KEY_RECAPTCHA_V3_ENTERPRISE');

  await new Promise((resolve) => {
    grecaptcha.enterprise.ready(resolve);
  });

  try {
    const token: string = await grecaptcha.enterprise.execute(siteKey, { action });

    if (!token) {
      throw new RecaptchaExecutionError('reCAPTCHA execute did not return a token');
    }

    return { token, action };
  } catch (error) {
    if (error instanceof RecaptchaExecutionError) {
      throw error;
    }
    const message = error instanceof Error ? error.message : String(error);
    throw new RecaptchaExecutionError(`Failed to execute reCAPTCHA: ${message}`);
  }
}
